import {
  Badge,
  Box,
  Card,
  Table,
  TableBody,
  TableBodyCell,
  TableBodyRow,
  TableHead,
  TableHeadCell,
  TableHeadRow,
  Text,
  theme,
} from "@aksara-ui/react";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import styled from "styled-components";
import TableBodyRowsSkeleton from "components/TableBodyRowSkeleton";
import moment from "moment";
import { getAllRaffleEvents } from "redux/actions";
import { InputSearchbox } from "components/Form/InputSearchbox";
import { toCapitilizeCase } from "utilities/helper/toCapitalizeCase";

const HeaderWrapper = styled(Box)`
  justify-content: space-between;
  margin-bottom: 30px;
  gap: 20px;
`;

const RaffleEventsContent: React.FC = () => {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ maxWidth: 576 });

  const { isLoading } = useSelector((state: any) => state.globalReducer);
  const { raffleEvents } = useSelector(
    (state: any) => state.raffleEventReducer
  );
  const { currentPage, limitPage } = useSelector(
    (state: any) => state.raffleEventReducer
  );

  const handleSearchChange = (event: any) => {
    dispatch(getAllRaffleEvents(1, event.target.value, limitPage) as any);
  };

  const handleClearSearchChange = () => {
    dispatch(getAllRaffleEvents(currentPage, "", limitPage) as any);
  };

  useEffect(() => {
    dispatch(getAllRaffleEvents() as any);
  }, [dispatch]);

  return (
    <Box height={"100%"} paddingY={20} paddingX={isMobile ? 30 : 50}>
      <HeaderWrapper
        display={"flex"}
        flexDirection={"column"}
        style={{ gap: 20 }}
      >
        <Box display={"flex"}>
          <Text scale={[500, 600]} fontWeight={700}>
            Event List
          </Text>
        </Box>

        <Box
          display={"flex"}
          flexDirection={isMobile ? "column" : "row"}
          justifyContent={"space-between"}
          style={{ gap: isMobile ? 10 : 20 }}
        >
          <InputSearchbox
            autoComplete="off"
            name="search"
            placeholder="Search..."
            size={32}
            onChange={handleSearchChange}
            onClearButton={handleClearSearchChange}
          />
        </Box>
      </HeaderWrapper>

      <Card maxHeight={"100%"} overflow={"auto"} elevation={2}>
        <Table>
          <TableHead
            position={"sticky"}
            top={0}
            backgroundColor={theme.colors.grey02}
          >
            <TableHeadRow>
              <TableHeadCell maxWidth={3}></TableHeadCell>
              <TableHeadCell>Name</TableHeadCell>
              <TableHeadCell>City</TableHeadCell>
              <TableHeadCell>Code</TableHeadCell>
              <TableHeadCell>Location</TableHeadCell>
              <TableHeadCell>Total Tickets</TableHeadCell>
              <TableHeadCell>Event Date</TableHeadCell>
            </TableHeadRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableBodyRowsSkeleton rowsNumber={10} columnsNumber={7} />
            ) : !raffleEvents.length ? (
              <TableBodyRow>
                <TableBodyCell colSpan={7} textAlign={"center"}>
                  No data available in table
                </TableBodyCell>
              </TableBodyRow>
            ) : (
              raffleEvents.map((event: any, index: any) => {
                return (
                  <TableBodyRow key={index}>
                    <TableBodyCell>
                      <Badge
                        size="md"
                        variant="success"
                        style={{
                          borderRadius: "100%",
                          padding: 10,
                        }}
                      >
                        {index + 1}
                      </Badge>
                    </TableBodyCell>
                    <TableBodyCell>{event.event_name}</TableBodyCell>
                    <TableBodyCell>
                      {toCapitilizeCase(event.city)}
                    </TableBodyCell>
                    <TableBodyCell>
                      {event.city_code}
                    </TableBodyCell>
                    <TableBodyCell>{event.location}</TableBodyCell>
                    <TableBodyCell>
                      <Badge
                        size="md"
                        variant="success"
                        style={{
                          paddingLeft: 20,
                          paddingRight: 20,
                        }}
                      >
                        {event.total_tickets.toLocaleString()}
                      </Badge>
                    </TableBodyCell>
                    <TableBodyCell>
                      {moment(event.event_date).format("DD MMMM YYYY")}
                    </TableBodyCell>
                  </TableBodyRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </Card>
    </Box>
  );
};

export default RaffleEventsContent;
